import { APP_ROUTES } from "enums/APP_ROUTES";
import { keyProjects, useStore } from "hooks/useStore";
import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import ProjectDto from "types/ProjectDto";
import useGetConfig from "./api/useGetConfig";

function getProjectPaths(slug: string): Record<APP_ROUTES, string> {
  return {
    [APP_ROUTES.SCRIPTS]: `/project/${slug}/scripts`,
    [APP_ROUTES.PARTICIPANTS]: `/project/${slug}/participants`,
    [APP_ROUTES.VIDEOS]: `/project/${slug}/videos`,
    [APP_ROUTES.PLAYLISTS]: `/project/${slug}/playlists`,
    [APP_ROUTES.DOCUMENTS]: `/project/${slug}/documents`,
    [APP_ROUTES.ADMINS]: `/project/${slug}/admins`,
    [APP_ROUTES.HYDRA]: `/project/${slug}/hydra`,
    [APP_ROUTES.PERSONAS]: `/project/${slug}/personas`,
  };
}

export default function useProject() {
  const project = useStore(
    (store) => store[keyProjects],
  ) as Partial<ProjectDto>;
  const { pathname } = useLocation();

  useGetConfig({ id: project.id });

  useEffect(() => {
    document.documentElement.scrollTop = 0;
  }, [pathname]);

  useEffect(() => {
    if (project.name && project.name.trim() !== "") {
      document.title = project.name;
    }
  }, [project.name]);

  return {
    ...project,
    projectId: project.id || "",
    projectPaths: getProjectPaths(project.slug || ""),
  };
}
